export const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://iep.kgeu.ru/api'
    : 'http://10.20.2.51:4000/api' || 'http://localhost:4000/api';
// export const API_URL = 'http://192.168.0.3:4000';
